export default __webpack_public_path__ + "static/media/Duffel.cc1a10f2.jpg";